import { render, staticRenderFns } from "./r-smart-offer-bundle-expd-treasure-gate.vue?vue&type=template&id=0b107f9e"
import script from "./r-smart-offer-bundle-expd-treasure-gate.vue?vue&type=script&lang=js"
export * from "./r-smart-offer-bundle-expd-treasure-gate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b107f9e')) {
      api.createRecord('0b107f9e', component.options)
    } else {
      api.reload('0b107f9e', component.options)
    }
    module.hot.accept("./r-smart-offer-bundle-expd-treasure-gate.vue?vue&type=template&id=0b107f9e", function () {
      api.rerender('0b107f9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-expedition-treasure/r-smart-offer-bundle-expd-treasure-gate.vue"
export default component.exports